// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isPromiseLike = <T = any>(obj: any): obj is { then: Promise<T>["then"] } =>
	obj !== null && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";

export default isPromiseLike;
